/**
 * TruLeads Simplification, UI Uplift & Metric Definition — 86eye7076 (Bayut KSA).
 *
 * Single source for the values the backend does not serve yet. Each export is a
 * one-line swap once the corresponding BE field/endpoint lands — replace the
 * literal with the real field and delete the TODO(BE) marker. Consumers already
 * prefer a real value when present (e.g. `data?.[slug] ?? MOCK`), so wiring BE is
 * a no-op on the UI side.
 */

// Clicked counts (Call/WhatsApp) and the Total Leads breakdown now come from the BE
// (product_stats + /leads/leads_summary), so the mocks were removed.

// TODO(BE): replace with the Last Interaction Source option list from BE
// (id/value + label). Query param key confirmed with BE in task 12/14.
export const LAST_INTERACTION_SOURCE_OPTIONS = [
  { id: 'call', name: 'Call' },
  { id: 'whatsapp', name: 'WhatsApp' },
  { id: 'email', name: 'Email' },
];

// Location now uses the shared CityLocationFilter (same fetch as /listings), so the
// static option list was removed.

/**
 * Tasking rule (task 15): a planned (next) task is OPTIONAL only when the completed task
 * TYPE is Lead Converted or Lead Lost; it is REQUIRED for every other type (Contact,
 * Meeting, Lead Confirm, Listing Preparation & Posting, …).
 *
 * Matched on the task-type NAME (from /api/surge/task_types), NOT the id — the ids differ
 * between environments (e.g. staging Lead Converted=11 / Lead Lost=12 vs production
 * Lead Converted=4 / Lead Lost=5) while the names are stable.
 */
export const OPTIONAL_PLANNED_TASK_TYPE_NAMES = ['Lead Converted', 'Lead Lost'];
